import React from 'react';
import "./index.less"
import { getCountryAsset } from "@/utils/countryAssetUtils";
/**
 * 作者: nick
 * 时间: 2023/6/9
 * 说明: 组件logo
 */

export interface LogoUIProps {
    showBig?: boolean;
}

const LogoUI = ({}: LogoUIProps) => {
    const logo = getCountryAsset("logo");
    return (
        <div className={"logo-ui"}>
            <img src={logo} alt="logo"/>
            {/* <img src={showBig ? pcPath : (isMobile ? mobilePath : pcPath)} alt="" /> */}
        </div>
    )
};

export default LogoUI;
